export default "__VITE_ASSET__CXfBuwod__"